import { W as WuiCheckInputGroup$1, d as defineCustomElement$1 } from './p-BPkWuDqM.js';

const WuiCheckInputGroup = WuiCheckInputGroup$1;
const defineCustomElement = defineCustomElement$1;

export { WuiCheckInputGroup, defineCustomElement };
